import { render, staticRenderFns } from "./IristarProgramme.vue?vue&type=template&id=6fb53fd0&"
import script from "./IristarProgramme.vue?vue&type=script&lang=js&"
export * from "./IristarProgramme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports